export const UploadStatusMessages = {
  FailedUploadTitle: "File Upload Failed",
  FailedUploadText:
    "Please ensure the file is under 5MB and in .jpg, .jpeg, .png, .heic, .heif, or .pdf format",
  FailedUploadButton: "Try Again",
};
